// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, restPasswordForgot } from '../../utils/Constants';

export const resetPasswordApi = createAsyncThunk('resetPasswordApi', async (payload) => {
    const token = localStorage.getItem("Token")
    const headers = {
        "Authorization": token, "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
    }
    try {
        const url = BASE_URL + restPasswordForgot
        const response = await axios.put(url, payload, { headers });
        return response.data;
    }
    catch (error) {
        throw error;
    }

});

const ResetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState: {
        data: null,
        isAuthenticated: false,
        loading: false,
        error: null,
    },
    reducers: {
        clearData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(resetPasswordApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(resetPasswordApi.fulfilled, (state, action) => {

                state.loading = false;
                state.data = action.payload;
                state.token = action.payload.token;
            })
            .addCase(resetPasswordApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});
export const { clearData } = ResetPasswordSlice.actions
export default ResetPasswordSlice.reducer;